import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {CapturePhotoDialog} from './Components/CapturePhotoDialog/CapturePhotoDialog'
import useCapturePhoto from './Components/CapturePhotoDialog/useCapturePhoto'
import {attachCameraToVideoEl, detachCameraFromVideoEl} from './Components/CapturePhotoDialog/useCapturePhoto'
import MovingProgress from './Components/MovingProgress'
import NetworkUsageToast from './Components/NetworkUsageToast/NetworkUsageToast'
import {ShowPhotoDialog} from './Components/ShowPhotoDialog/ShowPhotoDialog'
import {
  ANIMATION,
  AUDIO_REDUCER, ENABLE_IMAGE_ON_STT_AND_MANUAL,
  GENERAL_REDUCER,
  HEARING,
  INITIATOR_AUPRED,
  INITIATOR_HUMAN,
  IS_SHOWING_NETWORK_STATS,
  IS_TRANSCRIBING,
  LAST_INITIATOR,
  NETWORK_SPEED,
  NETWORK_USAGE,
  PLACE_HOLDER_MESSAGE,
  REFLECTED_CHAT,
  ROBOT_SPEAKING,
  SHOULD_FOCUS_INPUT_FIELD,
  SHOULD_FOCUS_SEND_BUTTON,
  STT_ENABLED, UPLOAD_MBPS,
  VIDEO_REDUCER
} from './redux/consts'
import {ReduxProvider} from './redux/store'
import {
  predict,
  onAppLoad,
  scrollText,
  playKeystroke,
  setShouldFocusSendButton,
  setShouldFocusInputField, audioSetSttEnabled, setCameraEnabled
} from './redux/actions'
import styles from './App.module.scss'
import SmartTextArea from './Components/SmartTextArea'
import {
  IS_CAMERA_ENABLED,
  CAPTURED_IMAGE,
  UPLOAD_SPEED_THRESHOLD_FOR_CAMERA
} from './redux/video/consts'

function InnerApp() {
  const [inputText, setInputText] = useState('')
  const dispatch = useDispatch()
  const buttonRef = useRef(null)
  const inputFieldRef = useRef(null)

  const reflectedChatRaw = useSelector(state => state.getIn([GENERAL_REDUCER,REFLECTED_CHAT]))
  const sttEnabled = useSelector(state => state.getIn([AUDIO_REDUCER, STT_ENABLED]))
  const isTranscribing = useSelector(state => state.getIn([AUDIO_REDUCER, IS_TRANSCRIBING]))
  const hearing = useSelector(state => state.getIn([AUDIO_REDUCER, HEARING])) // 'silence' | 'shaky'
  const robotSpeaking = useSelector(state => state.getIn([AUDIO_REDUCER, ROBOT_SPEAKING]))
  const cameraEnabled = useSelector(state => state.getIn([VIDEO_REDUCER, IS_CAMERA_ENABLED]))
  const isShowingNetworkStats = useSelector(state => state.getIn([GENERAL_REDUCER, IS_SHOWING_NETWORK_STATS]))
  const networkUsage = useSelector(state => state.getIn([GENERAL_REDUCER, NETWORK_USAGE]))
  const networkSpeed = useSelector(state => state.getIn([GENERAL_REDUCER, NETWORK_SPEED]))
  const animation = useSelector(state => state.getIn([GENERAL_REDUCER,ANIMATION]))
  const lastInitiator = useSelector(state => state.getIn([GENERAL_REDUCER, LAST_INITIATOR]))
  const liveVideoRef = useRef(null)

  const earState = robotSpeaking
    ? 'robotSpeaking'
    : !sttEnabled
      ? 'disabled'
      : isTranscribing
        ? 'transcribing'
        : hearing === 'shaky'
          ? 'shaky'
          : 'silence'

  const onToggleStt = () => {
    dispatch(audioSetSttEnabled(!sttEnabled))
  }

  // iterate through all assistant streams and if at least one of then is still active,
  // then we are not at the end of stream
  const endOfStream = useSelector(state => {
    // get last 2 rows of reflectedChat
    const reflectedChat = state.getIn([GENERAL_REDUCER,REFLECTED_CHAT])
    // endOfStream is true if amongst the last 2 reflectedChat entries, there exist a row
    // where both conditions are met: entry type=assistant and endOfStream true
    for (let i = reflectedChat.size-1; i >=0 && i>=reflectedChat.size-2; i--) { // always take last 2 chunks (typically user + assistant)
      const entry = reflectedChat.get(i)
      if (entry.get('role') === 'assistant') {
        if (!entry.get('endOfStream')) {
          return false
        }
      }
    }
    return true
  })

  useEffect(()=>{
    if (endOfStream) {
      dispatch(setShouldFocusInputField(true))
    }
  },[dispatch, endOfStream])

  const placeHolderMessage = useSelector(state => state.getIn([GENERAL_REDUCER,PLACE_HOLDER_MESSAGE]))

  useEffect(() => {
    dispatch(onAppLoad())
  }, [dispatch])

  useEffect(() => {
    dispatch(scrollText())
  },[reflectedChatRaw,dispatch])

  const [capturePhoto, stopCamera] = useCapturePhoto()


  useEffect(() => {
    if (!cameraEnabled) return
    capturePhoto({ toStore: false })
  }, [cameraEnabled, capturePhoto]) // keep eslint disable if needed because capturePhoto comes from hook


  useEffect(() => {
    if (!cameraEnabled) {
      detachCameraFromVideoEl(liveVideoRef.current)
      return
    }
    // gpt0217: start live preview in the rectangle (Redux still holds only snapshots)
    attachCameraToVideoEl(liveVideoRef.current)
  }, [cameraEnabled])



  const shouldFocusInputField = useSelector(state => state.getIn([GENERAL_REDUCER,SHOULD_FOCUS_INPUT_FIELD]))
  useEffect(() => {
    if (shouldFocusInputField && inputFieldRef.current) {
      if (lastInitiator !== INITIATOR_AUPRED) {
        inputFieldRef.current.focus()
      }
      dispatch(setShouldFocusInputField(false))
    }
  }, [shouldFocusInputField, dispatch, inputFieldRef, lastInitiator])


  const shouldFocusSendButton = useSelector(state => state.getIn([GENERAL_REDUCER,SHOULD_FOCUS_SEND_BUTTON]))
  useEffect(() => {
    if (shouldFocusSendButton && buttonRef.current) {
      buttonRef.current.focus()
      dispatch(setShouldFocusSendButton(false))
    }
  }, [shouldFocusSendButton, dispatch, buttonRef])

  const uploadMbps = useSelector(state => state.getIn([GENERAL_REDUCER,NETWORK_SPEED,UPLOAD_MBPS]))
  const handleSend = async () => {
    if (!inputText.trim()) return

    console.log('gizim', 7799135, 'uploadMbps=', uploadMbps)

    let image
    if (uploadMbps > UPLOAD_SPEED_THRESHOLD_FOR_CAMERA && cameraEnabled && ENABLE_IMAGE_ON_STT_AND_MANUAL) {
      console.log('embedding image from camera');
      image = await capturePhoto();
      console.warn('upload speed ok, camera enabled, and ENABLE_IMAGE_ON_STT_AND_MANUAL')
    } else {
      console.warn('upload speed too low, or camera disabled, or for performance reasons, on user prediction/stt, image is not added');
    }
    console.log('gizim', 6365966, 'image=', image?.substr(0,130));
    if (!image) {
      dispatch(predict({prompt:inputText,initiator:INITIATOR_HUMAN}))
    } else {
      const prompt = {
        content: inputText.trim(),
        extra: [{type: 'imageFile', base64Url: image}]
      }
      console.log('gizim', 7512540, 'dispatching prompt with image', inputText.trim());
      dispatch(predict({prompt,initiator:INITIATOR_HUMAN}))
    }
    setInputText('');
  };

  const onKeyDown = (e) => {
    dispatch(playKeystroke(true))
    if (e.key === 'Enter') {
      handleSend()
    }
  }

  let sendButtonText = 'Send'  // before any textCompletion is received

  useEffect(() => {
    const handleGlobalKey = (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const smartTextArea = document.getElementById('arnoldText');
        if (smartTextArea) {
          const delta = e.key === 'ArrowDown' ? 30 : -30;
          smartTextArea.scrollTop += delta;
          e.preventDefault();
        }
      }
    };

    window.addEventListener('keydown', handleGlobalKey);
    return () => window.removeEventListener('keydown', handleGlobalKey);
  }, []);

  return (
    <div className={styles.container}>
      {(animation>0 && lastInitiator === INITIATOR_AUPRED) ?
        <img className={styles.t800bg}
             src={require('Static/Images/aupred.png')}
             alt=""
        />
        :
        <img className={styles.t800bg}
           src={require('Static/Images/background.jpeg')}
           alt=""
        />
      }
      {lastInitiator !== INITIATOR_AUPRED && getAnimationImage(animation)}
      <div className={styles.content}>
        <CapturePhotoDialog/>
        <ShowPhotoDialog/>
        <div className={styles.inputWithButton}>
          <button
            type="button"
            className={`${styles.earButton} ${styles[`ear_${earState}`]}`}
            onClick={onToggleStt}
            aria-label={
              robotSpeaking
                ? 'Robot is speaking (mic paused)'
                : sttEnabled ? 'Disable speech-to-text' : 'Enable speech-to-text'
            }
            title={
              robotSpeaking
                ? 'Robot speaking (paused)'
                : sttEnabled ? 'Disable STT' : 'Enable STT'
            }
          >
            {robotSpeaking ? <RobotSpeakingIcon /> : <EarIcon />}
            {earState === 'transcribing' && <span className={styles.earSpinner} />}
            {!sttEnabled && !robotSpeaking && <span className={styles.earSlash} />}
          </button>

          <button
            type="button"
            className={styles.video_state}
            aria-label="video_state"
            title={cameraEnabled ? 'Disable camera' : 'Enable camera'}
            onClick={() => {
              if (cameraEnabled) {
                detachCameraFromVideoEl(liveVideoRef.current)
                stopCamera()
                dispatch(setCameraEnabled(false))
              } else {
                dispatch(setCameraEnabled(true))
              }

            }}
          >
            {cameraEnabled ? (
              <video
                ref={liveVideoRef}
                className={styles.video_state_video}
                autoPlay
                playsInline
                muted
              />
            ) : (
              <span className={styles.video_state_empty}>
                <CameraIcon />
                <span className={styles.videoSlash} />
              </span>
            )}

          </button>
          <input
            type="text"
            dir="auto"
            placeholder={`${endOfStream ? placeHolderMessage : ""}`}
            value={inputText}
            onChange={e => setInputText(e.target.value)}
            onKeyDown={onKeyDown}
            autoFocus
            ref={inputFieldRef}
          />
          <button onClick={handleSend}
                  ref={buttonRef}
                  >{sendButtonText}</button>
        </div>
        {animation && lastInitiator !== INITIATOR_AUPRED && <div className={styles.progressContainer}><MovingProgress/></div>}
        <SmartTextArea chatRaw={reflectedChatRaw} />
      </div>
      {isShowingNetworkStats && (
        <NetworkUsageToast
          key={networkUsage.get('measuredAt')}
          text={
            (networkUsage
              ? `Uploaded ${networkUsage.get('uploadGB')} GB  Downloaded ${networkUsage.get('downloadGB')} GB`
              : '') +
            (networkSpeed
              ? `  (Upload: ${Number(networkSpeed.get('uploadMbps')).toFixed(2)} Mbps, Download: ${Number(networkSpeed.get('downloadMbps')).toFixed(2)} Mbps)`
              : '') +
            (networkSpeed
              ? (networkSpeed.get('uploadMbps') > UPLOAD_SPEED_THRESHOLD_FOR_CAMERA ? ' 🐆' : ' 🐢')
              : '')
          }
        />
      )}
    </div>
  );
}


const getAnimationImage = (animation) => {
  switch (animation) {
    case 1:
      return <img className={styles.animation}
                  src={require('Static/Images/T800-walking.gif')}
                  alt=""
      />
    case 2:
      return <img className={styles.animation}
                  src={require('Static/Images/T800-illbeback.gif')}
                  alt=""
      />
    case 3:
      return <img className={styles.animation}
                  src={require('Static/Images/T800-glasses.gif')}
                  alt=""
      />
    case 4:
      return <img className={styles.animation}
                  src={require('Static/Images/matrix1.gif')}
                  alt=""
      />
    case 5:
      return <img className={styles.animation}
                  src={require('Static/Images/matrix2.gif')}
                  alt=""
      />
    default:
      break;
  }
}
const EarIcon = () => (
  <svg className="earSvg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2c-4.1 0-7.5 3.3-7.5 7.4v6c0 2.9 2.1 5.3 4.9 5.6.5.1 1-.3 1-.9 0-.5-.4-.9-.9-1-1.9-.2-3.3-1.8-3.3-3.7v-6C6.2 6.2 8.8 3.8 12 3.8c3.2 0 5.8 2.5 5.8 5.6 0 2.1-1.2 3.9-3 4.8-.4.2-.6.6-.5 1 .1.4.4.7.8.7h.2c2.4-1.1 4-3.5 4-6.5C19.3 5.3 16.1 2 12 2z" />
    <path d="M12.1 6.4c-2.1 0-3.8 1.7-3.8 3.8v5.6c0 1.6 1.2 3 2.8 3.2.5.1 1-.3 1-.8 0-.5-.3-.9-.8-1-0.7-.1-1.3-.7-1.3-1.5v-5.6c0-1.1.9-2 2-2 1.1 0 2 .9 2 2 0 .7-.4 1.3-1 1.7-.4.2-.5.7-.3 1.1.2.4.7.5 1.1.3 1.1-.6 1.8-1.8 1.8-3.1 0-2.1-1.7-3.7-3.7-3.7z" />
  </svg>
)

const RobotSpeakingIcon = () => (
  <svg className="earSvg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 10c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H7zm0 2h10v4H7v-4z" />
    <path d="M9 6c0-1.7 1.3-3 3-3s3 1.3 3 3v2H9V6zm2 0v2h2V6c0-.6-.4-1-1-1s-1 .4-1 1z" />
    <path d="M9 14.5a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8zm6 0a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8z" />
    <path d="M21 12.2c.6.5 1 1.2 1 1.8s-.4 1.3-1 1.8v-3.6zm-18 0v3.6c-.6-.5-1-1.2-1-1.8s.4-1.3 1-1.8z" />
  </svg>
)
const CameraIcon = () => (
  <svg className={styles.cameraSvg} viewBox="0 0 24 24" aria-hidden="true">
    {/* top housing */}
    <path
      d="M3 8.5c0-1.1.9-2 2-2h3l1.2-1.8c.3-.4.7-.7 1.2-.7h3.2c.5 0 .9.3 1.2.7L16 6.5h3c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-9z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />

    {/* outer lens ring */}
    <circle
      cx="12"
      cy="13"
      r="4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />

    {/* inner lens */}
    <circle
      cx="12"
      cy="13"
      r="2"
      fill="currentColor"
      opacity="0.35"
    />

    {/* shutter button detail */}
    <circle
      cx="17.5"
      cy="9.5"
      r="0.9"
      fill="currentColor"
    />
  </svg>
)




export default function App() {

  React.useLayoutEffect(() => {
    document.body.setAttribute("dir", "ltr")
  }, []);

  return <ReduxProvider>
    <InnerApp/>
  </ReduxProvider>

}
